import React, { Component } from 'react';
import './housetype.styles.scss';

class Housetype extends Component {
    render() {
        return (
            <div className='housetype'>
                <p>Apartment</p>
            </div>
        )
    }
}
export default Housetype;
